<template>
  <div>
  <v-row class="pt-0">
    <v-col cols="12" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <span class="head-search-text">ค้นหา</span>
      <v-autocomplete
        v-model="keywordName"
        :items="itemUserName"
        item-text="companyName"
        item-value="_id"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาได้จากชื่อเครือ, บริษัท"
        no-data-text="ไม่พบข้อมูล"
        @change="searchFilterData(), page=1"
        @click:clear="keywordName='', searchFilterData(), page=1"
      >
      <template v-slot:append>
        <img width="18" height="18" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
      </template>
      </v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="1" class="pt-0 d-flex align-end" style="padding-bottom: 15px;">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        :nudge-top='-10'
        max-width="328"
        left
        offset-y
        origin='left'
        tile
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="button-color-outline head-search-button"
            style="width: 96px; height: 38px;"
            text
            elevation="0"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left>
              mdi-filter-variant
            </v-icon>
            ตัวกรอง
          </v-btn>
        </template>
        <v-card class="pa-3">
          <v-row class="pt-3">
            <!-- <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">บริษัท</span>
              <v-autocomplete
                v-model="businessType"
                :items="itemDepartmen"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col> -->
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">สายบังคับบัญชา</span>
              <v-autocomplete
                v-model="department"
                :items="itemDepartmen"
                item-text="orgChartName"
                item-value="_id"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @change="searchFilterData()"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">สิทธิ์หลัก</span>
              <v-autocomplete
                v-model="primaryRole"
                :items="itemPrimaryRole"
                item-text="mainAuthenName"
                item-value="_id"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @change="searchFilterData()"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">สิทธิ์ย่อย</span>
              <v-autocomplete
                v-model="secondRole"
                :items="itemSecondRole"
                item-text="mainAuthenName"
                item-value="_id"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @change="searchFilterData()"
              >
              </v-autocomplete>
            </v-col>
            <!-- <v-col cols="12" class="pt-0 pb-0">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="datesCreateAt"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <span class="ra-span-text">วันที่สร้าง</span>
                  <v-text-field
                    class="mt-2"
                    :value="dateRangeTextCreate"
                    placeholder="ปป/ดด/วววว - ปป/ดด/วววว"
                    readonly
                    append-icon="fa-calendar-alt"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    clearable
                    @click:clear="resetCreateDate()"
                  >
                  <template v-slot:append>
                    <img width="20" height="20" src="@/assets/icons/today.png" >
                  </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="datesCreateAt" range>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu1 = false"
                  >
                    ยกเลิก
                  </v-btn>
                  <v-btn
                    v-if="datesCreateAt[0] !== undefined && datesCreateAt[1] !== undefined"
                    text
                    color="primary"
                    @click="$refs.menu1.save(datesCreateAt)"
                  >
                    ตกลง
                  </v-btn>
                  <v-btn
                    v-else
                    text
                    color="gray"
                    disabled
                  >
                    ตกลง
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="datesUpdateAt"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <span class="ra-span-text">วันที่อนุมัติ</span>
                  <v-text-field
                    :value="dateRangeTextUpdate"
                    placeholder="ปป/ดด/วววว - ปป/ดด/วววว"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    append-icon="fa-calendar-alt"
                    class="mt-2"
                    outlined
                    dense
                    clearable
                    @click:clear="resetUpdateDate()"
                  >
                  <template v-slot:append>
                    <img width="20" height="20" src="@/assets/icons/today.png" >
                  </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="datesUpdateAt" range
                >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu2 = false"
                >
                  ยกเลิก
                </v-btn>
                <v-btn
                  v-if="datesUpdateAt[0] !== undefined && datesUpdateAt[1] !== undefined"
                  text
                  color="primary"
                  @click="$refs.menu2.save(datesUpdateAt)"
                >
                  ตกลง
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="gray"
                  disabled
                >
                  ตกลง
                </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col> -->
          </v-row>
          <v-row class="d-flex">
            <v-spacer/>
            <v-btn
              class="button-color-outline head-search-button mr-2"
              outlined
              style="width: 60px;"
              elevation="0"
              @click="resetFilterData()"
            >ล้าง</v-btn>
            <v-btn
              class="button-color ml-2 mr-3"
              style="width: 94px;"
              dark
              @click="searchFilterData()"
            >ค้นหา</v-btn>
          </v-row>
        </v-card>
      </v-menu>
    </v-col>
    <v-spacer/>
  </v-row>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import {
  getSelectBusiness
} from '@/API/API'
// import axios from 'axios'
export default {
  name: 'filter-workgroup',
  props: {
    mode: String
  },
  data () {
    return {
      tapData: ['', 'waiting', 'pending', 'approve', 'reject', 'cancle'],
      tapSelect: 0,
      keywordName: '',
      keywordRequestNo: '',
      keywordPosition: [],
      keywordType: [],
      keywordCompanyName: [],
      keywordGroupCompanyName: [],
      itemUserName: [],
      itemPosition: [],
      itemCompanyName: [],
      itemGroupCompanyName: [],
      itemRequestType: [],
      clearUpdate: false,
      filterData: {
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.mode,
        limit: 50,
        page: 1
      },
      selectData: {
        companyName: [],
        requestType: [],
        status: [
          { value: 'pending', text: 'รออนุมัติ' },
          { value: 'approve', text: 'อนุมัติ' },
          { value: 'reject', text: 'ปฏิเสธอนุมัติ' },
          { value: 'cancle', text: 'ยกเลิก' }
        ],
        statusAct: [
          { value: 'pending', text: 'รอการรับทราบ' },
          { value: 'acknowledge', text: 'รับทราบ' }
        ]
      },
      menu: false,
      menu1: false,
      datesUpdateAt: [],
      datesCreateAt: [],
      menu2: false,
      createAt: '',
      updateAt: '',
      totalAll: 0,
      totalWaiting: 0,
      totalPending: 0,
      totalApproved: 0,
      totalRejected: 0,
      totalCancel: 0,
      allowBtnApprove: false,
      allowBtnReject: false,
      textBtnOk: this.mode === 'approve' ? 'Approve' : 'Acknowledge',
      textBtnNO: this.mode === 'approve' ? 'Reject' : 'Unacknowledge',
      approveRole: localStorage.approveRole,
      selectApproveRole: this.$store.state.user.role[1].permission,
      businessType: '',
      department: '',
      primaryRole: '',
      secondRole: '',
      itemDepartmen: [],
      itemPrimaryRole: [],
      itemSecondRole: []
    }
  },
  watch: {
    // approveRole () { return localStorage.approveRole }
    datesUpdateAt: function (val) {
      if (this.datesUpdateAt[0] !== undefined && this.datesUpdateAt[1] !== undefined) {
        this.updateAt = this.datesUpdateAt[0] + ' ' + this.datesUpdateAt[1]
        // this.searchFilterData()
      }
    },
    datesCreateAt: function (val) {
      if (this.datesCreateAt[0] !== undefined && this.datesCreateAt[1] !== undefined) {
        this.createAt = this.datesCreateAt[0] + ' ' + this.datesCreateAt[1]
        // this.searchFilterData()
      }
    }
  },
  computed: {
    // approveRole () { return localStorage.approveRole }
    dateRangeTextUpdate () {
      const chkDate = ''
      if (this.datesUpdateAt.length !== 0) {
        return this.datesUpdateAt.join(' ~ ')
      } else {
        return chkDate
      }
    },
    dateRangeTextCreate () {
      const chkDate = ''
      // return this.datesCreateAt.join(' ~ ')
      if (this.datesCreateAt.length !== 0) {
        return this.datesCreateAt.join(' ~ ')
      } else {
        return chkDate
      }
    }
  },
  async created () {
    // await this.getSelectData()
    await this.searchFilterData()
  },
  mounted () {
    // EventBus.$on('getPosition', this.getSelectData)
    EventBus.$on('getFilterฺTransferRole', this.getSelectValue)
    EventBus.$on('updateTotalMarket', this.updateTotal)
    EventBus.$on('setApproveRole', this.setApproveRole)
  },
  beforeDestroy () {
    EventBus.$off('manageTransferRoleSearch')
    EventBus.$off('updateTotalMarket')
    EventBus.$off('setApproveRole')
  },
  methods: {
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
      this.page = 1
      this.resetFilterData()
      // await this.getSelectData()
      await this.searchFilterData()
    },
    updateTotal (value) {
      this.totalAll = value.totalAll
      this.totalPending = value.totalPending
      this.totalApproved = value.totalApproved
      this.totalRejected = value.totalRejected
      this.totalWaiting = value.totalWaiting
      this.totalCancel = value.totalCancel
    },
    getSelectValue (filter) {
      this.itemUserName = filter.result[0].company
      this.itemDepartmen = filter.result[0].orgchart
      this.itemPrimaryRole = filter.result[0].mainAuthen
      this.itemSecondRole = filter.result[0].subAuthen
      // this.itemCompanyName = filter.result.businessTypeList
    },
    async getSelectData () {
      try {
        // const res = await getSelectApproveRequestCompany({ approveType: this.mode, role: this.approveRole }, this.$store.state.token)
        const res = await getSelectBusiness(this.$store.state.token)
        if (res.success) {
          if (res.result) {
          }
        }
      } catch (error) {
      } finally {
      }
    },
    resetUpdateDate () {
      this.updateAt = ''
      this.datesUpdateAt = []
      this.searchFilterData(1, 15)
    },
    resetCreateDate () {
      this.createAt = ''
      this.datesCreateAt = []
      this.searchFilterData(1, 15)
    },
    resetFilterData () {
      this.keywordName = ''
      this.department = ''
      this.primaryRole = ''
      this.secondRole = ''
      this.businessType = ''
      this.keywordName = ''
      this.keywordRequestNo = ''
      this.keywordPosition = []
      this.keywordType = []
      this.keywordCompanyName = []
      this.keywordGroupCompanyName = []
      this.createAt = ''
      this.updateAt = ''
      this.datesUpdateAt = []
      this.datesCreateAt = []
      this.filterData = {
        businessType: '',
        department: '',
        primaryRole: '',
        secondRole: '',
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        approveType: this.mode
      }
      this.searchFilterData(1, 15)
    },
    searchFilterData () {
      this.filterData = {
        company: this.keywordName,
        orgchart: this.department,
        mainAuthen: this.primaryRole,
        subAuthen: this.secondRole
        // role: this.approveRole
        // tab: this.mode
      }
      EventBus.$emit('manageTransferRoleSearch', this.filterData)
    },
    setObjFilter (data) {
      return (typeof data === 'string') ? [data] : data
    },
    removeChip (item) {
      const index = this.keywordType.indexOf(item.requestTypeEng)
      if (index >= 0) this.keywordType.splice(index, 1)
    }
  }
}
</script>

<style>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
</style>
